/* Saját főoldal: lapozható sávok (emlek-rail) és megjelenési animáció. jQuery nélkül. */
(function () {
  document.documentElement.classList.add('eh-js');

  if (!customElements.get('emlek-rail')) {
    customElements.define('emlek-rail', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-eh-track]');
        if (!this.track) return;
        this.prev = this.querySelector('[data-eh-prev]');
        this.next = this.querySelector('[data-eh-next]');
        this.bar = this.querySelector('[data-eh-progress]');
        this.onScroll = this.update.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      // egy oldalnyit lapoz, a látható kártyák szélességéhez igazítva
      go(dir) {
        const item = this.track.children[1] || this.track.children[0];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
        const perPage = Math.max(1, Math.floor((this.track.clientWidth - step * 0.3) / step));
        this.track.scrollBy({ left: dir * step * perPage, behavior: 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const x = this.track.scrollLeft;
        if (this.prev) this.prev.disabled = x <= 2;
        if (this.next) this.next.disabled = x >= max - 2;
        if (this.bar) {
          const ratio = this.track.scrollWidth ? this.track.clientWidth / this.track.scrollWidth : 1;
          const w = Math.min(100, Math.max(12, ratio * 100));
          const pos = max > 0 ? x / max : 0;
          this.bar.hidden = max <= 2;
          this.bar.style.setProperty('--eh-progress-w', w + '%');
          this.bar.style.setProperty('--eh-progress-x', ((100 - w) / w) * pos * 100 + '%');
        }
      }
    });
  }

  function reveal(root) {
    const items = (root || document).querySelectorAll('.eh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((el) => io.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => reveal());
  } else {
    reveal();
  }
  // témaszerkesztőben az újratöltött szekció azonnal látszódjon
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.eh-reveal').forEach((el) => el.classList.add('is-in'));
  });
})();
